import { ActionBase } from './ActionBase';
import { Store } from './Store';

import { reduceFunctions } from './Store';

export function reducer(state: Store, action: ActionBase): Store {
	let newStore = null;
	for (const reduceFunction of reduceFunctions) {
		if ((newStore = reduceFunction(state, action)) != null) {
			break;
		}
	}

	if (newStore == null) {
		newStore = state;
	}

	// console.log(`reducer[${JSON.stringify(newStore)}]`);

	return newStore;
}
